import { Footer } from '@/components/footer'
import { useResearchPageSeoHead } from '@/lib/research-page-seo-head'
import { Link } from 'react-router-dom'

export function CareerPage() {
  useResearchPageSeoHead({
    pagePath: '/career',
    contentLanguage: 'en',
    title: 'Careers at Mentiss AI',
    description: 'Explore opportunities to work on AI evaluation, multi-agent systems, and social-intelligence research at Mentiss.',
  })

  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <main className="flex-grow" lang="en">
        <div className="container mx-auto px-4 py-24 sm:px-6 lg:px-8">
          <div className="mx-auto max-w-3xl text-center">
            <div className="rounded-3xl border border-slate-200 bg-white/50 p-10 shadow-xl shadow-slate-200/50 backdrop-blur-xl dark:border-slate-800 dark:bg-slate-900/50 dark:shadow-none">
              <p className="text-left text-xl leading-relaxed text-slate-700 dark:text-slate-300">
                Mentiss is a focused team of three, and we are now looking for our fourth: a Sales & Marketing partner who truly understands the potential of our services to help us scale. We are looking for someone who believes in our vision and wants to be a foundational part of it.
              </p>
              <p className="text-left text-xl leading-relaxed text-slate-700 dark:text-slate-300">
                We currently operate without salaries—including the founders. In return, we offer high sales commissions and significant equity to align our long-term success. If this sounds good to you and you want to work with us, <Link to="/contact-us" className="font-bold text-slate-900 underline decoration-amber-500 underline-offset-4 transition-colors hover:text-amber-600 dark:text-white">contact us directly</Link>.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}
